import { render, staticRenderFns } from "./AdditionalFiltersNotSupported.vue?vue&type=template&id=2774807a&"
import script from "./AdditionalFiltersNotSupported.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFiltersNotSupported.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports